export default "__VITE_ASSET__CElugsrM__"